<template>
  <div>
    <el-dialog
      :title="type === 'create' ? '创建专辑' : '编辑专辑'"
      :visible="dialogVisible"
      :before-close="handleClose"
      @open="dialogOpen()"
      width="800px"
    >
      <div class="dialog-body">
        <div class="title-item">
          <div class="item-name">
            <span>*</span>
            专辑名称
          </div>
          <div class="item-content">
            <el-input
              placeholder="请输入专辑名称"
              v-model="info.title"
              clearable
              show-word-limit
              :maxlength="50"
            >
            </el-input>
            <div class="item-content-tip">
              <p>
                同步类
                ：学年+年级+学期/册别+学科+关键词（应用场景、资源类型）+版本/地区
              </p>
              <p>备考类 ：年份+学科+关键词（应用场景、资源类型）+地区</p>
            </div>
          </div>
        </div>
        <div class="description-item">
          <div class="item-name"><span>*</span>专辑简介</div>
          <div class="item-content">
            <el-input
              type="textarea"
              placeholder="请输入专辑简介，字数50-500"
              v-model="info.description"
              clearable
              :rows="5"
              resize="none"
              maxlength="500"
              minlength="50"
              show-word-limit
            >
            </el-input>
          </div>
        </div>
        <div class="subject-status-item">
          <div class="subject-item">
            <div class="item-name">
              <span>*</span>
              学科
            </div>
            <div class="item-content">
              <el-cascader
                placeholder="请选择学科"
                v-model="info.courseId"
                :options="subjectOptions"
                :props="{
                  value: 'id',
                  emitPath: false,
                }"
                :show-all-levels="false"
                @change="changeSubject"
              ></el-cascader>
            </div>
          </div>
          <div class="status-item">
            <div class="item-name">
              <span>*</span>
              完结状态
            </div>
            <div class="item-content">
              <el-select
                v-model="info.updateStatus"
                placeholder="请选择完结状态"
              >
                <el-option
                  v-for="item in statusOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
              <p class="status-tip">完结后无法再次修改</p>
            </div>
          </div>
        </div>
        <div class="grade-area-item">
          <div class="grade-item">
            <div class="item-name">
              <span>*</span>
              年级
            </div>
            <div class="item-content">
              <el-select
                v-model="info.gradeIds"
                multiple
                collapse-tags
                placeholder="请选择年级"
              >
                <el-option
                  v-for="item in gradeOptions"
                  :key="item.gradeId"
                  :label="item.name"
                  :value="item.gradeId"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="area-item">
            <div class="item-name">
              <span>*</span>
              地区
            </div>
            <div class="item-content">
              <el-select v-model="info.provinceId" placeholder="请选择地区">
                <el-option
                  v-for="item in areaOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog()">取消</el-button>
        <el-button
          @click="confirmAlbumInfo()"
          :disabled="!canSubmit"
          type="primary"
          >确定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import api from "@/assets/js/api";
export default {
  name: "ShopCenterAdminWebCreateAlbumDialog",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "create",
    },
    albumInfo: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      dialogVisible: false,
      info: {
        title: "",
        description: "",
        courseId: "",
        updateStatus: "",
        gradeIds: "",
        provinceId: "",
      },
      subjectOptions: [],
      gradeOptions: [], // 年级数据
      areaOptions: [], // 地区数据
      statusOptions: [
        // 完结状态数据
        {
          label: "更新中",
          value: "更新中",
        },
        {
          label: "已完结",
          value: "已完成",
        },
      ],
      courseAndStageMap: new Map(), // 学科与学段的哈希映射表
    };
  },
  watch: {
    show: {
      handler: function (val) {
        this.dialogVisible = val;
        if (val) {
          this.getStageAndSubject();
          this.getAreaList();
        }
      },
    },
  },
  computed: {
    // 是否可以提交
    canSubmit() {
      return (
        this.info.title &&
        this.info.courseId &&
        this.info.updateStatus &&
        this.info.gradeIds.length > 0 &&
        this.info.provinceId &&
        this.info.description.length > 0
      );
    },
  },
  mounted() {},

  methods: {
    dialogOpen() {
      if (this.type === "edit") {
        Object.assign(this.info, JSON.parse(JSON.stringify(this.albumInfo)));
      }
    },
    closeDialog() {
      this.$emit("update:show", false);
      this.info = {
        title: "",
        description: "",
        courseId: "",
        updateStatus: "",
        gradeIds: "",
        provinceId: "",
      };
    },
    handleClose(done) {
      done();
      this.closeDialog();
    },
    // 确定创建的专辑信息
    confirmAlbumInfo() {
      if (
        this.info.description.length < 50 ||
        this.info.description.length > 500
      ) {
        this.$message.error("专辑简介字数50-500之间");
        return;
      }
      this.$emit("getAlbumInfo", this.info);
      this.closeDialog();
    },
    // 获取学段学科
    async getStageAndSubject() {
      const res = await this.$axios.get(api.shopResource.getStageAndSubject);
      if (res.valid) {
        this.subjectOptions = res.result;
        // 建立学科与学段的哈希映射表
        res.result.forEach((item) => {
          this.setCourseAndStageMap(item.children, item.stageId);
        });
        if (this.info.courseId) {
          this.getGradeList(this.courseAndStageMap.get(this.info.courseId));
        }
      }
    },
    // 递归建立学科与学段的哈希映射表
    setCourseAndStageMap(data, stageId) {
      for (let i = 0; i < data.length; i++) {
        const item = data[i];
        if (!item.children || item.children.length === 0) {
          delete item.children;
          this.courseAndStageMap.set(item.id, stageId);
        } else {
          this.setCourseAndStageMap(item.children, stageId);
        }
      }
    },
    // 获取年级
    async getGradeList(stageId) {
      const res = await this.$axios.get(
        api.shopResource.getGradeList + "?stageId=" + stageId
      );
      // console.log(res);
      if (res.valid) {
        this.gradeOptions = res.result;
      }
    },
    // 获取地区
    async getAreaList() {
      const res = await this.$axios.get(api.shopResource.getAreaList);
      if (res.valid) {
        this.areaOptions = res.result;
      }
    },
    // 修改学科
    changeSubject() {
      // 清空年级
      this.info.gradeIds = "";
      // 根据学科的学段 获取对应的年级
      this.getGradeList(this.courseAndStageMap.get(this.info.courseId));
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog-body {
  padding-top: 20px;
  & > div {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 25px;
    .item-name {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      width: 70px;
      margin-right: 20px;
      color: #606266;
      font-weight: 600;
      span {
        margin-right: 5px;
        color: #fe4509;
        font-weight: 600;
      }
    }
    & > .item-content {
      position: relative;
      width: 600px;
      .item-content-tip {
        position: absolute;
        bottom: -10px;
        left: 0;
        & > p {
          color: #c4c8d0;
          font-size: 12px;
          font-style: normal;
          font-weight: 400;
          line-height: 20px;
        }
      }
    }
  }
  .title-item {
    margin-bottom: 55px;
    .item-content {
      position: relative;
      .item-content-tip {
        position: absolute;
        bottom: -46px;
        left: 1px;
        & > p {
          color: #c4c8d0;
          font-size: 12px;
          font-style: normal;
          font-weight: 400;
          line-height: 20px;
        }
      }
    }
  }
  .description-item {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    .item-name {
      transform: translateY(6px);
    }
  }
  .subject-status-item,
  .grade-area-item {
    display: flex;
    align-items: center;
    justify-content: center;
    & > div {
      display: flex;
      align-items: center;
      justify-content: flex-start;
    }
    & > :first-child {
      margin-right: 125px;
    }
  }
  .status-item {
    .item-content {
      position: relative;
      .status-tip {
        position: absolute;
        left: 0;
        bottom: -18px;
        color: #c4c8d0;
        font-size: 12px;
        line-height: 12px; /* 100% */
      }
    }
  }
}
.dialog-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  & > :first-child {
    margin-right: 20px;
  }
}
</style>
